//
//
//
//
//
//
//
//

export default {
    name: "imgtoast",
    props:{
      img:''
    },
    data(){

    }
}



// WEBPACK FOOTER //
// ./src/components/common/imgtoast.vue